import { render, staticRenderFns } from "./SystemTagManagementPagination.vue?vue&type=template&id=02edaf31&scoped=true"
import script from "./SystemTagManagementPagination.vue?vue&type=script&lang=js"
export * from "./SystemTagManagementPagination.vue?vue&type=script&lang=js"
import style0 from "./SystemTagManagementPagination.vue?vue&type=style&index=0&id=02edaf31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02edaf31",
  null
  
)

export default component.exports